import { render, staticRenderFns } from "./NationalTrademarkSearchStatus.vue?vue&type=template&id=0968fb75&"
import script from "./NationalTrademarkSearchStatus.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkSearchStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports